import script from "./WOrganizationDetailSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./WOrganizationDetailSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./WOrganizationDetailSidebar.vue?vue&type=style&index=0&id=1dc9f846&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc9f846"]])

export default __exports__